/*
 *   File : brokers.js
 *   Author : https://evoqins.com
 *   Description : Added Stock brokers page
 *   Integrations : 
 *   Version : 1.0.0
*/


import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

// Components
import { PrimaryButton, TextButton } from "../../Component/Buttons";
import { Chip } from "../../Component/Others";
import { APIService } from "../../Service";
import { toast } from "react-toastify";
import { ConnectBrokerModal } from "../../Component/Modal";
import { Modal } from "bootstrap";
import { _getProfile, _scrollToTop } from "../../Helper";


function Brokers() {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const navigate = useNavigate();
    const selected_broker = useRef({});

    const [showBrokerModal, setShowBrokerModal] = useState(false);


    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, []);

    useEffect(() => {
        if (showBrokerModal === true) {
            const broker_modal = new Modal(document.getElementById('connect-modal'));
            broker_modal.show();
        }
    }, [showBrokerModal]);


    // handle navigate to connect broker
    const _handleConnectBroker = () => {
        navigate("/account/connect-broker");
    };

    // handle open confirm modal
    const _handleOpenConfirmModal = (broker_data) => {
        setShowBrokerModal(true);
        selected_broker.current = broker_data;
    };

    // handle change default broker 
    const _handleChangeDefaultBroker = () => {
        // API - Call
        _changeDefaultBroker();
    };

    // handle close modal
    const _handleCloseBrokerModal = () => {
        setShowBrokerModal(false);
    };


    //==================================== //
    //=========== API CAllS ============== //

    // Validate broker
    const _changeDefaultBroker = async () => {
        let url = "broker/mapping";
        let data = {
            "user_id": USER_DATA.unique_identifier,
            "broker_name": selected_broker.current.broker_name,
            "client_code": selected_broker.current.client_code,
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            toast.dismiss();
            toast.success(`${selected_broker.current.broker_name} set as your default broker successfully`);
            setShowBrokerModal(false);
            // Update Broker list
            _getProfile(USER_DATA.unique_identifier);

            // Saving broker data in local storage
            let broker_data = {
                "broker_id": selected_broker.current.broker_id,
                "broker_name": selected_broker.current.broker_name,
                "execution_partner": selected_broker.current.broker_name,
                "client_code": selected_broker.current.client_code,
            };

            localStorage.setItem("indvestment_connected_broker", JSON.stringify(broker_data));

        } else {
            toast.dismiss();
            toast.success(response.message);
        }
    };



    return (
        <div className="row h-100 mb-4">
            <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
                    <TextButton name="Mapped Brokers"
                        icon={true}
                        labelClass="e-font-16-res"
                        type={2}
                        onPress={() => navigate(-1)} />
                    {
                        USER_DATA.user_brokers_info.length !== 0 &&
                        <PrimaryButton name="Add New Broker Account"
                            icon={true}
                            className="border-radius-40"
                            padding="padding-12px-tb padding-20px-lr"
                            onPress={() => navigate("/account/connect-broker")} />
                    }
                </div>
            </div>
            <div className="col-lg-8 min-vh-100">
                {/* Brokers list */}
                <div className="p-3 card-box-shadow h-100 e-bg-white">

                    {
                        USER_DATA.user_brokers_info.length === 0 ?
                            <div className="text-center mt-4  col-md-10 mx-auto">
                                <img src={require("../../Assets/Images/Modal/connect-broker-img.webp")}
                                    draggable={false}
                                    width={220}
                                    alt='broker' />
                                <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                                    Connect with Broker
                                </h4>
                                <p className='px-5 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px mb-3'>
                                    You haven’t connected your broker account. Please connect to proceed with investing in curated baskets.
                                </p>

                                <PrimaryButton name="Connect with Stock Brokers"
                                    className="col-11 mt-1"
                                    onPress={_handleConnectBroker} />

                            </div>
                            :
                            <>

                                <h2 className="e-font-16-res mb-4 e-text-chinese-black e-primary-font-clash-display e-font-weight-500 e-font-18 line-height-24px pe-3 pe-sm-0">
                                    Switch to Other Mapped Brokers
                                </h2>
                                <div className="d-flex flex-column gap-3">
                                    {
                                        USER_DATA.user_brokers_info.map((broker, key) => (
                                            <div key={key}
                                                className="d-flex align-items-center e-border-1px-anti-flash-white py-1 py-sm-2 pe-2 px-sm-3 border-radius-16">
                                                <img src={broker.broker_logo}
                                                    width={40}
                                                    height={40}
                                                    className="col-auto border-radius-8 me-2"
                                                    alt={broker.broker_name} />
                                                <span className="col-auto e-text-charleston-green e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px e-letter-spacing-min-point-1px">
                                                    {broker.broker_name}
                                                </span>
                                                {
                                                    broker.default ?
                                                        <Chip label="Default" className="ms-auto e-text-very-light-blue e-border-1px-very-light-blue e-bg-lavender-web" />
                                                        :
                                                        <TextButton name="Set as default"
                                                            className="ms-auto"
                                                            labelClass="e-font-14-res e-letter-spacing-min-point-2px"
                                                            onPress={() => _handleOpenConfirmModal(broker)} />
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                            </>
                    }
                </div>
            </div>

            {/* Confirm modal - broker change */}
            <ConnectBrokerModal type={3}
                selected_broker_name={selected_broker.current.broker_name}
                handleClose={_handleCloseBrokerModal}
                handleSuccess={_handleChangeDefaultBroker} />
        </div>

    )
}

export default Brokers